export const formsNames = {
    CREATE_KIT_TYPE_FORM: 'CREATE_KIT_TYPE_FORM',
    CREATE_MATERIAL_TYPE_FORM: 'CREATE_MATERIAL_TYPE_FORM',
    UPDATE_KIT_PLIES_FORM: 'UPDATE_KIT_PLIES_FORM',
    QPL_FORM: 'QPL_FORM',
    QPL_TEST_FORM: 'QPL_TEST_FORM',
    COC_TEST_FORM: 'COC_TEST_FORM',
  };
